module.exports = __webpack_public_path__ + "yz/img/京东.c491a431.jpg";